/** Every spelling of a module we have in the wild -> its route segment.
 *  Codes come from ProductCode ('ENG'), notifications ('ENGAGEMENT') and url segments ('eng').
 *  Values are route paths from app-routing.module.ts — NOT ModuleName lowercased
 *  ('Assessment' lives at 'assessment360', 'Exit' at 'exit-v2'). */
const ROUTE_BY_CODE: Record<string, string> = {
    ENG: 'engagement',
    ENGAGEMENT: 'engagement',
    HAP: 'happiness',
    HAPPINESS: 'happiness',
    EXIT: 'exit-v2',
    ONB: 'onboarding',
    ONBOARDING: 'onboarding',
    WLB: 'wellbeing',
    WELLBEING: 'wellbeing',
    ASM: 'assessment360',
    ASSESSMENT: 'assessment360',
    ASM180: 'assessment180',
    ASSESSMENT180: 'assessment180',
    PSY: 'psychometric',
    PSYCHOMETRIC: 'psychometric',
    SX: 'survey-x',
    SURVEYX: 'survey-x',
};

/** 'ENG' | 'eng' | 'Engagement' -> 'engagement'. Unknown -> undefined (don't navigate). */
export function resolveModuleRoute(code: string): string | undefined {
    return ROUTE_BY_CODE[code?.toUpperCase().replace(/[-_\s]/g, '')];
}
